import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { authApi, setUnauthorizedHandler } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  // null = checking, object = authenticated, false = anonymous
  const [user, setUser] = useState(null);
  const refresh = useCallback(async () => {
    try { setUser(await authApi.refreshMe()); } catch { setUser(false); }
  }, []);
  useEffect(() => {
    setUnauthorizedHandler(() => setUser(false));
    // CRITICAL: If returning from OAuth callback, skip the /me check; AuthCallback handles it.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);
  const logout = async () => {
    try { await authApi.logout(); } finally { setUser(false); }
  };
  return <AuthCtx.Provider value={{ user, setUser, refresh, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="frz-page"><div className="frz-center frz-muted" data-testid="auth-checking">…</div></div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  return children;
};

export const startGoogleLogin = (next = "/studio") => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + next;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
